module.exports = __webpack_public_path__ + "static/vegetariana200-01621c5025c6da2bd686cf347609ebb7.png";